/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Locked_TooltipInputs */



/**
* | output |
* | --- |
* | "The agent cannot be changed once the conversation has started" |
*
* @param {Agent_Builder_Locked_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_locked_tooltip = /** @type {((inputs?: Agent_Builder_Locked_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Locked_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Agent kann nach Beginn der Konversation nicht mehr geändert werden")
	return /** @type {LocalizedString} */ ("The agent cannot be changed once the conversation has started")
});